import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { TaskListItem } from "@/app/Tasks/GraphQL/taskListQuery";
import { TaskType } from "@/gql/graphql";
import { BookingCompleteTaskDialog } from "@/app/Tasks/Components/BookingCompleteTaskDialog";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";

export function useTaskActions(): ActionsHook<TaskListItem> {
  const { open } = useDialog(BookingCompleteTaskDialog);

  return (task) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                isHidden: task.type !== TaskType.ConfirmRelocationWasCompleted,
                label: "Resolve",
                handleAction: () => {
                  open({ task });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
